(function () {
  if (window.__reelSoundToggleLoaded) return;
  window.__reelSoundToggleLoaded = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-reel-sound-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    var card = toggle.closest('.reel-card');
    var video = card && card.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    toggle.classList.toggle('is-muted', video.muted);
    toggle.setAttribute('aria-pressed', String(!video.muted));
    toggle.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
  });
})();
